import {Route, Routes} from 'react-router-dom'
import {Registration} from './views/Registration'
import {ForgotPassword} from './views/ForgotPassword'
import {Login} from './views/Login'
import {AuthLayout} from './AuthLayout'
import {ResetPassword} from './views/ResetPassword'
import {ErrorsPage} from '../errors/ErrorsPage'
import {VerifyRegistration} from './views/VerifyRegistration'
import Verify2FA from '../onboarding/views/Verify2FA'
import { useAuth } from './core/Auth'

const AuthPage = () => {
  const {
    twoFaToken
  } = useAuth()
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path='login' element={<Login />} />
        <Route path='registration' element={<Registration />} />
        <Route path='forgot-password' element={<ForgotPassword />} />
        <Route path='reset-password/:token' element={<ResetPassword />} />
        <Route path='verify-otp/:userId' element={<VerifyRegistration />} />
        {twoFaToken ? <Route path='2fa-verification' element={<Verify2FA />} /> : null}
      </Route>
      <Route path='*' element={<ErrorsPage />} />
    </Routes>
  )
}

export {AuthPage}
